import { render, staticRenderFns } from "./FlowXOverview.vue?vue&type=template&id=6cb979f4&scoped=true"
import script from "./FlowXOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./FlowXOverview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FlowXOverview.vue?vue&type=style&index=0&id=6cb979f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb979f4",
  null
  
)

export default component.exports